import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=43fa75fb"
import script from "./MyDocuments.vue?vue&type=script&lang=js"
export * from "./MyDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports